import React, { useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import moment from "moment";

import CardArrow from "@areas/shared/components/cards/CardArrow";
import Pagination from "@areas/shared/components/paginations/Pagination";
import { toRutubeEmbedUrl } from "@helpers/rutube";

import styles from "../blocks/styles/addition.module.css";
import paginationStyles from "@areas/employer/components/pagination/styles/pagination.module.css";

const DEFAULT_PROMTOUR_IMAGE = "/static/media/default-company.a1b57740.jpg";

const PROMTOUR_TYPES = {
  1: "Профориентационный тур",
  2: "День открытых дверей",
  3: "Экскурсия",
};

function PromtourCardImage({ item }) {
  const [src, setSrc] = useState(() =>
    item.Image
      ? `/v1/api/fileManager/getFile?path=${item.Image}`
      : DEFAULT_PROMTOUR_IMAGE
  );

  useEffect(() => {
    setSrc(
      item.Image
        ? `/v1/api/fileManager/getFile?path=${item.Image}`
        : DEFAULT_PROMTOUR_IMAGE
    );
  }, [item.Id, item.Image]);

  const handleError = () => {
    setSrc((current) =>
      current !== DEFAULT_PROMTOUR_IMAGE ? DEFAULT_PROMTOUR_IMAGE : current
    );
  };

  return (
    <img
      src={src}
      alt={item.Title || "Профтур"}
      className={styles.promtourImage}
      onError={handleError}
    />
  );
}

function PromtourCardMedia({ item }) {
  const embedUrl = toRutubeEmbedUrl(item.VideoUrl);

  if (embedUrl) {
    return (
      <iframe
        src={embedUrl}
        title={item.Title || "Профтур"}
        className={styles.promtourVideo}
        allow="clipboard-write; autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      />
    );
  }

  return <PromtourCardImage item={item} />;
}

function PromtoursTab({ load, results, limit, onChangePage }) {
  return (
    <>
      {load ? (
        <div className="d-flex justify-content-center w-100">
          <ClipLoader />
        </div>
      ) : results.data.length > 0 ? (
        <div className={styles.tabContent}>
          <div className={styles.promtours}>
            {results.data.map((item) => (
              <CardArrow
                key={item.Id}
                sizeArrow={{ width: 17, height: 17 }}
                customStyles={{
                  main: styles.card,
                  border: styles.border,
                  arrow: styles.arrow,
                }}
                rotate="leftTop"
              >
                <div className={styles.inner}>
                  <div className={styles.promtourCard}>
                    <PromtourCardMedia item={item} />
                    <div className={styles.promtourInfo}>
                      <div className={styles.dates}>
                        {item.Date
                          ? moment(item.Date).format("DD.MM.YYYY")
                          : null}
                      </div>
                      <div className={styles.title}>{item.Title}</div>
                      {PROMTOUR_TYPES[item.IdType] ? (
                        <div className={styles.subtitle}>
                          {PROMTOUR_TYPES[item.IdType]}
                        </div>
                      ) : null}
                      {item.Description ? (
                        <div className={styles.description}>
                          <div className={styles.title}>Описание:</div>
                          {item.Description}
                        </div>
                      ) : null}
                      {item.Industry ? (
                        <div className={styles.description}>
                          <div className={styles.title}>Отрасль:</div>
                          {item.Industry}
                        </div>
                      ) : null}
                      {item.City ? (
                        <div className={styles.description}>
                          <div className={styles.title}>Город/район:</div>
                          {item.City}
                        </div>
                      ) : null}
                      {item.TargetGroup ? (
                        <div className={styles.description}>
                          <div className={styles.title}>Целевая группа:</div>
                          {item.TargetGroup}
                        </div>
                      ) : null}
                      {item.ParticipantsCount !== null &&
                      item.ParticipantsCount !== undefined ? (
                        <div className={styles.description}>
                          <div className={styles.title}>
                            Количество участников:
                          </div>
                          {item.ParticipantsCount}
                        </div>
                      ) : null}
                      {item.ContactPerson ? (
                        <div className={styles.description}>
                          <div className={styles.title}>Контактное лицо:</div>
                          {item.ContactPerson}
                        </div>
                      ) : null}
                      {item.Address ? (
                        <div className={styles.description}>
                          <div className={styles.title}>Адрес:</div>
                          {item.Address}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </CardArrow>
            ))}
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center w-100">
          Ничего не найдено
        </div>
      )}
      <Pagination
        load={load}
        itemsPerPage={limit}
        totalItems={results.total}
        onChangePage={onChangePage}
        customStyles={{
          prev: paginationStyles.prev,
          current: paginationStyles.current,
          next: paginationStyles.next,
        }}
      />
    </>
  );
}

export default PromtoursTab;
